module.exports = __webpack_public_path__ + "img/CAPA-PEQUENA_REVISTA-332x454px.d362267b.png";